import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PageHeaderModule, ResultModule, SEModule, STModule, SVModule } from '@delon/abc';
import { DelonFormModule } from '@delon/form';
import { AlainThemeModule } from '@delon/theme';
import { NgxNeditorModule } from '@notadd/ngx-neditor';
import { DelonACLModule } from '@delon/acl';
import { IccMsgGeneratorComponent } from './components/icc-msg-generator/icc-msg-generator.component';
import { IccPatchDialogComponent } from './components/icc-patch-dialog/icc-patch-dialog.component';
import { IccShortChainConfigComponent } from './components/icc-short-chain-config/icc-short-chain-config.component';
import { IccMsgFormComponent } from './components/icc-msg-form/icc-msg-form.component';
import { IccFakeTextAreaComponent } from './components/icc-fake-textarea/icc-fake-textarea.component';
import { ConditionComponent } from './components/condition/condition.component';
import { IccPatchPopoverComponent } from './components/icc-patch-popover/icc-patch-popover.component';
import { SmartGroupComponent } from './components/smart-group/smart-group.component';
import { IccTplConditionComponent } from './components/icc-tpl-group/icc-tpl-condition.component';
import { IccTplCopyComponent } from './components/icc-tpl-group/icc-tpl-copy.component';
import { IccTplHeaderComponent } from './components/icc-tpl-group/icc-tpl-header.component';
import { IccTplNameComponent } from './components/icc-tpl-group/icc-tpl-name.component';
import { IccTplOperateComponent } from './components/icc-tpl-group/icc-tpl-operate.component';
import { IccTplVariableComponent } from './components/icc-tpl-group/icc-tpl-variable.component';
import { IccSideMenuComponent } from './components/icc-side-menu/icc-side-menu.component';
import { IccStateComponent } from './components/icc-state/icc-state.component';
import { IccImageComponent } from './components/icc-image/icc-image.component';
import { IccImageUploadComponent } from './components/icc-image-upload/icc-image-upload.component';
import { IccButtonComponent } from './components/icc-button/icc-button.component';
import { IccVideoComponent } from './components/icc-video/icc-video.component';
import { IccAudioComponent } from './components/icc-audio/icc-audio.component';
import { IccAudioUploadComponent } from './components/icc-audio-upload/icc-audio-upload.component';
import { IccTagsComponent } from './components/icc-tags/icc-tags.component';
import { IccMsgIconComponent } from './components/icc-msg-icon/icc-msg-icon.component';
import { ConditionTableAuditComponent } from './components/condition-table-audit/condition-table-audit.component';
import { IccIconComponent } from './components/icc-icon/icc-icon.component';
import { InnerHtmlPipe } from './pipe/inner-html.pipe';
import { TextFormatPipe } from './pipe/text-format.pipe';
import { HttpDirective } from './directive/http.directive';
import { NgZorroAntdModule, NzFormModule, NZ_I18N, zh_CN } from 'ng-zorro-antd';
import { Icc5GContentComponent } from './components/icc-5g-content/icc-5g-content.component';
import { Icc5GCardComponent } from './components/icc-5Gcard/icc-5Gcard.component';
import { IccAnchorComponent } from './components/icc-anchor/icc-anchor.component';
import { Icc5gEditorComponent } from './components/icc-5GEditor/icc-5g-editor.component';
import { IccCardComponent } from './components/icc-card/icc-card.component';
import { IccChannelTableComponent } from './components/icc-channel-table/icc-channel-table.component';
import { IccCollapsComponent } from './components/icc-collaps/icc-collaps.component';
import { IccCommentCardComponent } from './components/icc-comment-card/icc-comment-card.component';
import { IccCommentPannelComponent } from './components/icc-comment-pannel/icc-comment-pannel.component';
import { IccDateComponent } from './components/icc-date/icc-date.component';
import { IccHeadUploadComponent } from './components/icc-head-upload/icc-head-upload.component';
import { IccListComponent } from './components/icc-list/icc-list.component';
import { IccMapPositionComponent } from './components/icc-map-position/icc-map-position.component';
import { IccMaterialTabComponent } from './components/icc-material-tab/icc-material-tab.component';
import { IccMediaEditorComponent } from './components/icc-media-editor/icc-media-editor.component';
import { IccMediaSelectComponent } from './components/icc-media-select/icc-media-select.component';
import { IccMsgContentComponent } from './components/icc-msg-content/icc-msg-content.component';
import { IccMsgTplComponent } from './components/icc-msg-tpl/icc-msg-tpl.component';
import { IccMultiLineCellComponent } from './components/icc-multi-line-cell/icc-multi-line-cell.component';
import { IccOrderComponent } from './components/icc-order/icc-order.component';
import { IccTableTextComponent } from './components/icc-table-text/icc-table-text.component';
import { IccToggleComponent } from './components/icc-toggle/icc-toggle.component';
import { IccUploadComponent } from './components/icc-upload/icc-upload.component';
import { EmptyDataComponent } from './components/report/empty-data/empty-data.component';
import { IccFunnelVoiceSendComponent } from './components/report/icc-funnel-voice-send/icc-funnel-voice-send.component';
import { IccRadioMsgSendComponent } from './components/report/icc-radio-msg-send/icc-radio-msg-send.component';
import { IccRadioSmsChannelComponent } from './components/report/icc-radio-sms-channel/icc-radio-sms-channel.component';
import { IccReportComponent } from './components/report/icc-report/icc-report.component';
import { IccTotalBiztypeSendComponent } from './components/report/icc-total-biztype-send/icc-total-biztype-send.component';
import { IccTotalMoEmailComponent } from './components/report/icc-total-mo-email/icc-total-mo-email.component';
import { IccTotalSendComponent } from './components/report/icc-total-send/icc-total-send.component';
import { IccTotalMoSmsComponent } from './components/report/icc-total-mo-sms/icc-total-mo-sms.component';
import { IccTotalWechatFansComponent } from './components/report/icc-total-wechat-fans/icc-total-wechat-fans.component';
import { IccTrendSendComponent } from './components/report/icc-trend-send/icc-trend-send.component';
import { IccTrendVoiceTimeComponent } from './components/report/icc-trend-voice-time/icc-trend-voice-time.component';
import { IccTrendWechatIndicatorComponent } from './components/report/icc-trend-wechat-indicator/icc-trend-wechat-indicator.component';
import { ChannelComponent } from './components/biztype/channel/channel.component';
import { AdDirective } from './directive/ad.directive';
import { ValidateNameDirective } from './directive/validate.name';
import { CommonModule } from '@angular/common';
import { MsgTypesDirective } from './directive/msgTypes.directive';
import { BtnGroupComponent } from './components/btn-group/btn-group.component';
import { WechatRefComponent } from './components/wechat-ref/wechat-ref.component';



const SHARED_DELON_MODULES = [PageHeaderModule, STModule, SEModule, SVModule, ResultModule];

const IMPORTMODULES = [
  NgZorroAntdModule,
  NzFormModule,
  HttpClientModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  DelonFormModule.forRoot(),
  NgxNeditorModule,
  AlainThemeModule.forChild(),
  DelonACLModule,
  ...SHARED_DELON_MODULES
]
// 自定义组件
const COMPONENTS = [
  ConditionComponent,
  ConditionTableAuditComponent,

  Icc5GContentComponent,
  Icc5GCardComponent,
  Icc5gEditorComponent,
  IccAnchorComponent,
  IccCardComponent,
  IccChannelTableComponent,
  IccCollapsComponent,
  IccCommentCardComponent,
  IccCommentPannelComponent,
  IccDateComponent,
  IccHeadUploadComponent,
  IccListComponent,
  IccMapPositionComponent,
  IccMaterialTabComponent,
  IccMediaEditorComponent,
  IccMediaSelectComponent,
  IccMsgContentComponent,
  IccMsgTplComponent,
  IccMultiLineCellComponent,
  IccOrderComponent,
  
  IccTableTextComponent,
  IccToggleComponent,
  IccUploadComponent,
  EmptyDataComponent,
  IccFunnelVoiceSendComponent,
  IccRadioMsgSendComponent,
  IccRadioSmsChannelComponent,
  IccReportComponent,
  IccTotalBiztypeSendComponent,
  IccTotalMoEmailComponent,
  IccTotalMoSmsComponent,
  IccTotalSendComponent,
  IccTotalWechatFansComponent,
  IccTrendSendComponent,
  IccTrendVoiceTimeComponent,
  IccTrendWechatIndicatorComponent,
  ChannelComponent,

  IccMsgGeneratorComponent,
  IccPatchDialogComponent,
  IccShortChainConfigComponent,
  IccMsgFormComponent,
  IccFakeTextAreaComponent,
  IccPatchPopoverComponent,
  SmartGroupComponent,
  IccTplConditionComponent,
  IccTplCopyComponent,
  IccTplHeaderComponent,
  IccTplNameComponent,
  IccTplOperateComponent,
  IccTplVariableComponent,
  IccSideMenuComponent,
  IccStateComponent,
  IccImageComponent,
  IccImageUploadComponent,
  IccButtonComponent,
  IccVideoComponent,
  IccAudioComponent,
  IccAudioUploadComponent,
  IccTagsComponent,
  IccMsgIconComponent,
  IccIconComponent,

  BtnGroupComponent,
  WechatRefComponent
]

const COMPONENTS_NOROUNT = [Icc5GCardComponent, IccMediaSelectComponent, IccPatchDialogComponent, IccShortChainConfigComponent, SmartGroupComponent, IccTplOperateComponent, IccTplNameComponent, IccTplCopyComponent, IccTplConditionComponent, IccTplHeaderComponent, IccTplVariableComponent,IccMapPositionComponent]

@NgModule({
  declarations: [
    ...COMPONENTS,
    InnerHtmlPipe,
    TextFormatPipe,
    HttpDirective,
    AdDirective,
    ValidateNameDirective,
    MsgTypesDirective
  ],
  imports: [
    ...IMPORTMODULES
  ],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN }
  ],
  entryComponents: [...COMPONENTS_NOROUNT],
  exports: [
    IccMsgGeneratorComponent,
    IccPatchDialogComponent,
    IccShortChainConfigComponent,
    IccMsgFormComponent,
    IccFakeTextAreaComponent,
    ConditionComponent,
    IccPatchPopoverComponent,
    SmartGroupComponent,
    IccTplConditionComponent,
    IccTplCopyComponent,
    IccTplHeaderComponent,
    IccTplNameComponent,
    IccTplOperateComponent,
    IccTplVariableComponent,
    IccSideMenuComponent,
    IccStateComponent,
    IccImageComponent,
    IccImageUploadComponent,
    IccButtonComponent,
    IccVideoComponent,
    IccAudioComponent,
    IccAudioUploadComponent,
    IccTagsComponent,
    IccMsgIconComponent,
    ConditionTableAuditComponent,
    IccIconComponent,

    Icc5GContentComponent,
    Icc5GCardComponent,
    Icc5gEditorComponent,
    IccAnchorComponent,
    IccCardComponent,
    IccChannelTableComponent,
    IccCollapsComponent,
    IccCommentCardComponent,
    IccCommentPannelComponent,
    IccDateComponent,
    IccHeadUploadComponent,
    IccListComponent,
    IccMapPositionComponent,
    IccMaterialTabComponent,
    IccMediaEditorComponent,
    IccMediaSelectComponent,
    IccMsgContentComponent,
    IccMsgTplComponent,
    IccMultiLineCellComponent,
    IccOrderComponent,

    IccTableTextComponent,
    IccToggleComponent,
    IccUploadComponent,
    EmptyDataComponent,
    IccFunnelVoiceSendComponent,
    IccRadioMsgSendComponent,
    IccRadioSmsChannelComponent,
    IccReportComponent,
    IccTotalBiztypeSendComponent,
    IccTotalMoEmailComponent,
    IccTotalMoSmsComponent,
    IccTotalSendComponent,
    IccTotalWechatFansComponent,
    IccTrendSendComponent,
    IccTrendVoiceTimeComponent,
    IccTrendWechatIndicatorComponent,
    // 指令
    InnerHtmlPipe,
    TextFormatPipe,
    HttpDirective,
    AdDirective,
    ValidateNameDirective,
    // 模块
    NgZorroAntdModule,
    NzFormModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DelonFormModule,
    NgxNeditorModule,
    AlainThemeModule,
    DelonACLModule,
    ...SHARED_DELON_MODULES,
    BtnGroupComponent,
    WechatRefComponent
  ]
})
export class CommonLibModule { }
